export default{
    'noAccount': ["Create an Account", "Already have an account?"],
    'register': ['Join now', 'Sign in', 'Register now'],
    'browser': 'Recommend using the latest Google browser for the best results',
    'browser1': 'Recommend to use',
    'browser2': 'Google',
    'browser3': 'or',
    'browser4': 'IE11',
    'browser5': 'browser for better exeprience',
    'resigerTitle': 'Account Information',
    'changeResiger': ['Use phone number to register', 'Use email to register'],
    'btnText': ['Sign in', 'Register'],
    'companyInfo': 'Company Information',
    'personInfo': 'Personal Information',
    'overseasCompanyInfo': 'The information of overseas headquarters company.',
    'back': 'Back',
    'validateFail': 'Validation failed',
    'notAccount': 'This Email is not registered, register now?',
    'notAccount2': 'This phone number is not registered, register now?',
    'anotherAccount': 'You can log in with another account',
    'fillInformation': 'Fill in the registration information',
    'bringInInformation': 'Same with my company information'
}